import React from "react";
// import classnames from 'classnames'

// import styles from './style.css'
// NOTE: Versión typescript
// type Props = {
//   children?: React.Node,
//   className?: string,
// }

// const Title = (props: Props): React.Element<*> => (
//   <h1 className={classnames(styles.title, props.className)}>{props.children}</h1>
// )

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

// export default Title
import logo from "../../../assets/images/logo_bindbox.svg";

const Logo = props => (
  <img
    src={logo}
    alt="logo BindBox"
    style={{ width: "100%", maxWidth: "200px" }}
  />
);

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default Logo;
